'use strict';

require('./follow_merchant_modal');

const MIN_MODAL_WIDTH = 767;
Groupon.FollowMerchantMainContent = class FollowMerchantMainContent {
  constructor(el, csrf, showNearbyPlaces) {
    this.el = el;
    this.csrf = csrf;
    this.showNearbyPlaces = showNearbyPlaces;
    this.$container = $(this.el);
    this.$mainContentContainer = this.$container.find(
      '.follow-merchant-main-full'
    );
    this.$followMainContent = this.$container.find('.follow-merchant-info');
    this.$cta = this.$container.find('.post-follow-cta');
    this.$loading = this.$container.find('.loading');
    this.$followButton = this.$container.find(
      '#follow-merchant-main-content-btn'
    );
    this.initBindings();
    $('.mpp-container').removeClass('no-merchant-offer');
  }

  initBindings() {
    $('#follow-merchant-main-content-btn').click(() => {
      this.showLoading();
      this.mainWidgetFollow = true;
      return this.$container.trigger('follow-requested');
    });
    $('.follow-merchant-righthand-module').on(
      'follow-successful',
      (event, data) => {
        this.hideLoading();

        if (this.mainWidgetFollow) {
          this.mainWidgetFollow = false;

          if (this.showNearbyPlaces && $(window).width() > MIN_MODAL_WIDTH) {
            this.showModal(data);
          }
        }

        return this.showCTA();
      }
    );
    $('.follow-merchant-righthand-module').on('follow-unsuccessful', () => {
      return this.removeWidget();
    });
    return $('.follow-merchant-righthand-module').on(
      'unfollow-successful',
      () => {
        return this.removeWidget();
      }
    );
  }

  showLoading() {
    this.$followButton.addClass('hide');
    return this.$loading.show();
  }

  hideLoading() {
    this.$loading.hide();
    return this.$followButton.removeClass('hide');
  }

  showCTA() {
    return this.$followMainContent.fadeOut(200, () => {
      this.$followMainContent.hide();
      return this.$cta.fadeIn(200);
    });
  }

  showModal(data) {
    this.followModal = new Groupon.FollowMerchantModal(
      '#follow-merchant-nearby-places-modal',
      data,
      this.csrf
    );
    return this.followModal.openModal();
  }

  removeWidget() {
    this.$mainContentContainer.slideUp(200, () => this.$container.remove());
    return $('.mpp-container').addClass('no-merchant-offer');
  }
};
